module.exports = __webpack_public_path__ + "static/img/title3.a74612e0.png";